import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="N" transform="translate(11.000000, 5.000000)">
        <path
          d="M28.541667,61 L28.541667,30.3 L33.341667,30.3 L45.891667,49.25 L45.891667,30.3 L50.691667,30.3 L50.691667,61 L45.841667,61 L33.341667,42.05 L33.341667,61 Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
